import React from 'react'
import SvgWrapper from '../SvgWrapper'
import type { IllustrationProps } from './types'

const NothingFoundIllustration: React.FC<IllustrationProps> = ({ width = 160, height = 150 }) => (
  <SvgWrapper height={height} width={width} viewBox="0 0 160 150" fill="none">
    <path
      d="M61.776 19.828a6.214 6.214 0 0 0-6.207 6.207v9.716a6.214 6.214 0 0 0 6.207 6.208h9.716A6.214 6.214 0 0 0 77.7 35.75v-9.716a6.214 6.214 0 0 0-6.208-6.207h-9.716ZM93.764 46.98a6.214 6.214 0 0 0-6.208 6.207v9.716a6.214 6.214 0 0 0 6.208 6.208h9.716a6.214 6.214 0 0 0 6.207-6.208v-9.716a6.214 6.214 0 0 0-6.207-6.207h-9.716Z"
      fill="#FF0080"
    />
    <path d="m79.857 144.775-1.974-.016-.873-7.791 2.913.024-.066 7.783Z" fill="#604134" />
    <path
      d="M73.535 147.914a.883.883 0 0 0 .875.89l3.924.033.687-1.393.253 1.4 1.48.014-.374-4.993-.515-.034-2.101-.145-.678-.045-.012 1.412-3.152 2.139a.88.88 0 0 0-.387.722Z"
      fill="#020537"
    />
    <path d="m89.9 144.775-1.974-.016-.874-7.791 2.913.024-.065 7.783Z" fill="#604134" />
    <path
      d="M83.578 147.914a.883.883 0 0 0 .874.89l3.925.033.687-1.393.252 1.4 1.481.014-.374-4.993-.515-.034-2.101-.145-.678-.045-.012 1.412-3.153 2.139a.88.88 0 0 0-.386.722Z"
      fill="#020537"
    />
    <path
      d="m72.112 81.787 8 .252 7.58 1.685s-.757.926 1.77 3.453c0 0 3.368 5.895 1.01 11.622l-1.01 22.908s2.946 16.148.694 21.288l-2.975.186-5.035-21.288-2.454-22.925-1.18 22.57s4.511 15.493 1.663 21.643l-3.223-.186-5.514-21.457s-2.358-24.76-2.021-29.477c.337-4.716 2.695-10.274 2.695-10.274Z"
      fill="#2E35A8"
    />
    <path
      d="M98.98 45.589a2.046 2.046 0 0 0-.634 3.671v.003l-.156 3.758 2.876 1.331.23-5.783h-.02a2.043 2.043 0 0 0-2.296-2.98Z"
      fill="#604134"
    />
    <path
      d="M82.907 59.002a3.277 3.277 0 0 1-.968-2.294 3.279 3.279 0 0 1 1.588-2.875 3.292 3.292 0 0 1 3.712.182l9.03 6.8 1.61-9.796 3.455 1.113-.825 12.755a2.561 2.561 0 0 1-1.349 2.102 2.563 2.563 0 0 1-2.498-.028l-13.05-7.426a3.36 3.36 0 0 1-.705-.533Z"
      fill="#A5A9DA"
    />
    <path
      d="M69.136 40.11a2.046 2.046 0 0 1-2.134 3.054l-.002.002-2.536 2.778-2.98-1.08 3.91-4.268.013.014a2.046 2.046 0 0 1 3.729-.5Z"
      fill="#604134"
    />
    <path
      d="m70.231 60.835-14.496-3.916a2.563 2.563 0 0 1-1.794-1.738 2.563 2.563 0 0 1 .523-2.443l8.395-9.639 3.236 1.643-5.754 8.09 11.2 1.529a3.292 3.292 0 0 1 2.766 2.483 3.28 3.28 0 0 1-.898 3.16 3.277 3.277 0 0 1-3.178.83Z"
      fill="#A5A9DA"
    />
    <path
      d="m90.898 85.157-20.271.93c-.557-.846-.406-2.117.374-3.709 2.944-6.01.708-17.382-.796-23.303-.422-1.66.71-3.312 2.416-3.483l1.911-.19 1.767-5.394h6.188l2.567 2.932 4.356 2.647c-.793 8.168-4.171 19.702.642 25.486 1.053 1.265 1.351 2.633.846 4.084Z"
      fill="#A5A9DA"
    />
    <path d="M78.606 50.132a6.027 6.027 0 1 0 0-12.054 6.027 6.027 0 0 0 0 12.054Z" fill="#604134" />
    <path
      d="M85.426 40.248c.838-3.058-8.3-5.68-10.077-3.217-.247-.35-1.16-.563-1.578-.456-.419.108-.77.376-1.115.636-.472.363-.962.739-1.252 1.26-.291.52-.337 1.229.056 1.68.312.358.859 2.264 1.327 2.359.326.066.601.12.837.159.211-.307.748-.693.709-1.065.318.21.202.581.138.96-.214 1.26-5.02 11.014-2.268 8.14.273.16.61.31.999.448.66-.994 1.2-2.167 1.557-3.393l.002.023c.123 1.066.902 1.94 1.932 2.238 4.133 1.198 7.476-.56 8.626-3.728-.421-.854-.604-.761-.567-.787a.99.99 0 0 1 1.474.47c.067.174.127.323.18.435.599-2.143 1.311-1.833-.98-6.162Z"
      fill="#020537"
    />
    <path
      d="m82.575 38.03-.422-2.159c-.036-.181-.07-.378.012-.544.105-.213.376-.301.61-.267.236.034.412.248.645.29.814.143 1.889-.66 2.18 1.372.122.848 1.474.937 1.925 1.664.451.727.507 1.777-.11 2.371-.491.474-1.282.53-1.92.287-.64-.243-1.153-.732-1.601-1.248-.448-.517-.854-1.075-1.37-1.523"
      fill="#020537"
    />
    <path
      d="M85.748 41.312c-1.65-.23-2.773-.83-3.341-1.782-.743-1.247-.246-2.62-.224-2.678l.349.13c-.005.013-.457 1.27.196 2.36.508.85 1.541 1.388 3.071 1.602l-.051.368ZM93.487 17.992c-4.848 0-8.793-3.945-8.793-8.794 0-4.848 3.945-8.793 8.793-8.793 4.848 0 8.793 3.945 8.793 8.793 0 4.849-3.945 8.794-8.793 8.794Zm0-14.07a5.282 5.282 0 0 0-5.276 5.276 5.282 5.282 0 0 0 5.276 5.276 5.282 5.282 0 0 0 5.276-5.276 5.282 5.282 0 0 0-5.276-5.275Z"
      fill="#2E35A8"
    />
    <path
      d="M107.016 23.968c-.431 0-.863-.158-1.202-.476l-8.253-7.735a1.757 1.757 0 0 1-.08-2.485 1.754 1.754 0 0 1 2.484-.08l8.253 7.734c.71.664.746 1.777.081 2.485a1.75 1.75 0 0 1-1.283.556Z"
      fill="#2E35A8"
    />
    <path
      d="M.02 149.25c0 .191.154.345.345.345h159.27a.344.344 0 1 0 0-.689H.365a.343.343 0 0 0-.345.344Z"
      fill="#020537"
    />
  </SvgWrapper>
)

export default NothingFoundIllustration
